import { motion } from 'framer-motion';
import { SOCIAL_LINKS } from '@/lib/constants';
import { Instagram, Play } from 'lucide-react';

export default function InstagramFeed() {
  const instagramPosts = [
    { id: 1, media: '/images/instagram/image_2.jpg', type: 'image' },
    { id: 2, media: '/images/instagram/image_3.jpg', type: 'image' },
    { id: 3, media: '/images/instagram/image_4.jpg', type: 'image' },
    { id: 4, media: '/images/instagram/image_5.jpg', type: 'image' },
    { id: 5, media: '/images/instagram/image_6.jpg', type: 'image' },
    { id: 6, media: '/images/instagram/image_7.jpg', type: 'image' },
    { id: 7, media: '/images/instagram/video_1.mp4', type: 'video' },
  ];

  const duplicatedPosts = [...instagramPosts, ...instagramPosts, ...instagramPosts];

  return (
    <div className="relative py-20 bg-white overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-white via-transparent to-white z-10 pointer-events-none" />
      
      <div className="flex animate-scroll hover:[animation-play-state:paused] py-10">
        {duplicatedPosts.map((post, index) => (
          <motion.a
            key={`${post.id}-${index}`}
            href={SOCIAL_LINKS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ y: -20 }}
            className="relative flex-shrink-0 w-80 h-80 mx-4 rounded-sm overflow-hidden group border border-white/5 shadow-2xl"
          >
            {post.type === 'video' ? (
              <video
                src={post.media}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
                muted loop playsInline
                onMouseEnter={(e) => e.currentTarget.play()}
                onMouseLeave={(e) => { e.currentTarget.pause(); e.currentTarget.currentTime = 0; }}
              />
            ) : (
              <img
                src={post.media}
                alt="Delta BJJ"
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-110"
                loading="lazy"
              />
            )}
            
            <div className="absolute inset-0 bg-brand-black/40 group-hover:bg-transparent transition-colors duration-500" />
            
            {/* Overlay Icon */}
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
              <div className="w-16 h-16 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white group-hover:text-brand-blue transition-colors">
                {post.type === 'video' ? <Play className="w-6 h-6 fill-current" /> : <Instagram className="w-6 h-6" />}
              </div>
            </div>

            <div className="absolute bottom-6 left-6 text-white/40 text-[10px] font-bold tracking-[0.3em] uppercase opacity-0 group-hover:opacity-100 transition-opacity">
              @deltabjj
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  );
}
